function validateName(name: string | undefined): boolean {
  if (!name) return false;
  const trimmedName = name.trim();
  if (trimmedName.length < 2 || trimmedName.length > 50) return false;
  if (!/^[a-zA-Z0-9 ]+$/.test(trimmedName)) return false;
  return true;
}

export default validateName;
